import "./styles";
import "@fontsource-variable/inter";
import "../shared/lib/i18n";

import { Toaster } from "@mychili/clarity-ui";
import { QueryClientProvider, RouterProvider } from "./providers";

export const App = () => {
  return (
    <QueryClientProvider>
      <RouterProvider />
      <Toaster />
    </QueryClientProvider>
  );
};
